import { render, staticRenderFns } from "./WarehouseTabRequirement.vue?vue&type=template&id=150b0424"
import script from "./WarehouseTabRequirement.vue?vue&type=script&lang=js"
export * from "./WarehouseTabRequirement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports